import clsx from "clsx";
import makeStyles from "@mui/styles/makeStyles";
import { Grid } from "@mui/material";
import { palette } from "../../../theme/palette";
import { RouteLabel } from "../../Layers/RouteLabelLayer/RouteLabel";
import { View } from "../../Base";
import { EditPickupPartnerToggle } from "./EditPickupPartnerToggle";

const useStyles = makeStyles({
  columnContainer: {
    height: "1.6rem",
    display: "flex",
  },
  routeLabelContainer: {
    width: "86px",
    display: "flex",
    justifyContent: "center",
  },
  routeLabelGrid: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "white",
    borderRadius: "4px",
    boxShadow: `0px 2px 3px ${palette.typography.black.high}`,
    minHeight: "30px",
  },
  spacing: {
    padding: "2px",
  },
});

export const EditPickupPartnerColumn = ({
  routeEdit,
  onEdit,
  anchorEl,
  setAnchorEl,
  routeCodes,
  popupLabels,
  value,
}) => {
  const styles = useStyles();
  return (
    <View className={styles.columnContainer}>
      <EditPickupPartnerToggle
        routeEdit={routeEdit}
        onEdit={onEdit}
        value={value}
      />
      <View
        className={styles.routeLabelContainer}
        onClick={(e) => {
          e.stopPropagation();
          const routesCount = Object.keys(popupLabels).length;
          setAnchorEl(!anchorEl && routesCount ? e.currentTarget : null);
        }}
      >
        <View>
          <Grid container className={styles.routeLabelGrid}>
            {routeCodes.length > 6 ? (
              <Grid
                item
                container
                xs
                className={clsx(styles.spacing)}
                direction={"row"}
              >
                <RouteLabel routeCode={"M"} />
              </Grid>
            ) : (
              routeCodes.map((routeCode, index) => (
                <Grid
                  key={index}
                  item
                  container
                  xs={routeCodes.length >= 3 ? 4 : 12 / routeCodes.length}
                  className={clsx(styles.spacing)}
                  direction={"row"}
                >
                  <RouteLabel routeCode={routeCode} />
                </Grid>
              ))
            )}
          </Grid>
        </View>
      </View>
    </View>
  );
};
